module.exports = __webpack_public_path__ + "static/img/about-certificate-04.56883d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-04.jpg
// module id = 9Tns
// module chunks = 1